

export const ToastAlertType = {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success'
}